import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';

import { actions } from 'react-redux-form';
import {
    //model
    wirelessChangePricePlanModel
    //action
    , setPrimaryPlanDetails
    , setSubscriptionDetails
    , setVendorDetails
    , setPlanOptions
    , setOtherPlanOptions
    , setFormSubmitted
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-change-price-plan.settings';

export const changePricePlanModelAInitialState = wirelessChangePricePlanModel;

const planDetailConst = {
    PlanId: 0
    , ComponentName: ''
    , ComponentCost: 0
    , ComponentDetails: ''
    , IsPrimary: false
}

const defaultState = () => ({
    simOptions: []
    , planOptions: []
    , otherPlanOptions: []  
    , subscription: {}
    , formSubmitted: false
    , vendorDetails: {
        Currency: ''
    }
    , primaryPlanDetails: { ...planDetailConst }
});

const initialState = defaultState();


export const wirelessChangePricePlanActions = {

    onReplaceSimFormLoad: () => (dispatch, state) => {
    }

    , onSubscriptionSelect: (value, propsName, objects) => async (dispatch, state) => {

        const { wirelessChangePricePlanFormA } = state().form;

        if (value === '') {
            dispatch({ type: setSubscriptionDetails, data: {} });
            resetWirelessChangePricePlanForm(dispatch);
            resetWirelessChangePricePlanModel(dispatch);
        } else {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CircuitId != wirelessChangePricePlanFormA.circuitId) {
                resetWirelessChangePricePlanForm(dispatch);
                resetWirelessChangePricePlanModel(dispatch);
                dispatch(actions.change('wirelessChangePricePlanFormA.circuitCode', value));
                dispatch(actions.change('wirelessChangePricePlanFormA.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });

                let vendor = await getVendorDetails(dispatch, obj);

                if (vendor) {
                    updatePlanTypes(dispatch, vendor.VendorDetailId);
                }

            }
        }
    }
    , onPlanSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));
        dispatch(actions.change('wirelessChangePricePlanFormA.planDetailsModel', wirelessChangePricePlanModel.planDetailsModel));
        dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
        dispatch({ type: setOtherPlanOptions, data: initialState.otherPlanOptions });
        updatePlanDetails(dispatch, value);

    }
    , onOtherPlanSelect: (e) => async (dispatch, state) => {

        const { otherPlanOptions } = state().wirelessChangePricePlanRequest;
        const { wirelessChangePricePlanFormA } = state().form;
        var selectedObj = otherPlanOptions.find(x => x.PlanComponentId == e.target.value);
        var newOtherPlans = [...wirelessChangePricePlanFormA.planDetailsModel];

        if (e.target.checked) {
            newOtherPlans.push(selectedObj);
        } else {

            const indexOfObject = wirelessChangePricePlanFormA.planDetailsModel.findIndex(o => {
                return o.PlanComponentId == e.target.value;
            });

            newOtherPlans.splice(indexOfObject, 1);
        }


        dispatch(actions.change('wirelessChangePricePlanFormA.planDetailsModel', newOtherPlans));
    }
    , submitRequest: () => async (dispatch, state) => {

        const { wirelessChangePricePlanFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { subscription } = state().wirelessChangePricePlanRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }

        //---->to be refactored 
        dispatch(actions.change('wirelessChangePricePlanFormA.planDetails.planComponents', wirelessChangePricePlanFormA.planDetailsModel));
        //---->end

        var data = {
            ChangeRequestModel: {
                ...userData

                , CircuitId: subscription.CircuitId
                , VendorDetailId: subscription.VendorDetailId
                , BusinessJustification: wirelessChangePricePlanFormA.businessJustification
                , AdditionalInformation: wirelessChangePricePlanFormA.additionalInformation
                , PlanDetailsModel: wirelessChangePricePlanFormA.planDetailsModel
                , RequestTypeId: requestTypeId
                , NoEmail: true
            },
            NewPlanId: wirelessChangePricePlanFormA.planId,
            IsAmending: false
        };

        dispatch({ type: setFormSubmitted, data: true });
        var res = await httpPost('external/changePlan/submitChangePlan', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelessChangePricePlanForm: () => (dispatch) => {
        resetWirelessChangePricePlanForm(dispatch);
    }
    , resetWirelessChangePricePlanModel: () => (dispatch) => {
        resetWirelessChangePricePlanModel(dispatch);
    }
}

async function updatePlanDetails(dispatch, id) {
    var res = await httpGet('external/orderRequest/getPlanComponentByPlan/' + id);

    if (res != null && res.length > 0) {

        //dispatch(actions.change('wirelessChangePricePlanFormA.planDetailsModel', res));

        var primaryPlan = res.filter(x => x.IsPrimary === true);

        if (primaryPlan != null && primaryPlan.length > 0) {

            dispatch(actions.change('wirelessChangePricePlanFormA.planDetailsModel', primaryPlan));

            dispatch({
                type: setPrimaryPlanDetails,
                data: primaryPlan[0]
            });
        } else {
            dispatch({ type: setOtherPlanOptions, data: res });
        }

    } else {

        dispatch({ type: setOtherPlanOptions, data: initialState.otherPlanOptions });
    }
}

async function getVendorDetails(dispatch, subscription) {

    var data = {
        VendorDetailId: subscription.VendorDetailId,
        CircuitTypeId: subscription.CircuitTypeId,
    };

    var res = await httpPost('external/orderRequest/getVendorDetails', data);

    if (res != null) {
        dispatch({ type: setVendorDetails, data: res });
    } else {
        dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails} });
    }

    return res;
}

async function updatePlanTypes(dispatch, id) {
    var res = await httpGet('external/orderRequest/getPlanByVendor/' + id);
    if (res != null && res.length > 0) {
        dispatch({ type: setPlanOptions, data: res });
    } else {
        dispatch({ type: setPlanOptions, data: [] });
    }
}

function resetWirelessChangePricePlanForm(dispatch) {
    dispatch({ type: setVendorDetails, data: { ...defaultState.vendorDetails } });
    dispatch({ type: setPlanOptions, data: [] });
    dispatch({ type: setPrimaryPlanDetails, data: planDetailConst });
    dispatch({ type: setOtherPlanOptions, data: initialState.otherPlanOptions });
    dispatch({ type: setFormSubmitted, data: false });
}

function resetWirelessChangePricePlanModel(dispatch) {
    dispatch(actions.reset('wirelessChangePricePlanFormA'));
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: { ...action.data }
            };
        case setPrimaryPlanDetails:
            return {
                ...state,
                primaryPlanDetails: action.data
            };
        case setPlanOptions:
            return {
                ...state,
                planOptions: action.data
            };
        case setOtherPlanOptions:
            return {
                ...state,
                otherPlanOptions: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };

        default: return state;
    }
}